import { FadeUp } from "@/components/site/Reveal";

const PARTNERS = [
  { name: "APP", note: "China / Indonesia", img: "/mills/app.png" },
  { name: "Three M Paper Boards Ltd", note: "Paperboard", img: "/mills/threem.png" },
  { name: "Tirthak Paper Mill", note: "Duplex Board", img: "/mills/tpm.png" },
  { name: "N R Agarwal Industries Ltd", note: "Paper & Board", img: "/mills/nragarwal.png" },
];

export const Partners = () => {
  return (
    <section id="partners" data-testid="partners-section" className="bg-muted py-28 md:py-40 border-t border-border">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <FadeUp>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
            <div>
              <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary mb-6">/ Authorised Dealer Of</p>
              <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">
                The mills we<br /> represent.
              </h2>
            </div>
            <p className="text-muted-foreground max-w-sm">
              Official dealership across leading domestic and international paper mills — including Tulsi Paper Mill.
            </p>
          </div>
        </FadeUp>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-border border border-border">
          {PARTNERS.map((p, i) => (
            <FadeUp key={p.name} delay={i * 0.08}>
              <div
                className="group bg-card h-full flex flex-col items-center justify-between p-8 md:p-10 transition-colors duration-500 hover:bg-background"
                data-testid={`partner-card-${i}`}
              >
                <div className="flex-1 w-full flex items-center justify-center py-6">
                  <img
                    src={p.img}
                    alt={p.name}
                    className="max-h-28 w-auto object-contain transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="text-center border-t border-border pt-5 w-full">
                  <h3 className="font-display text-lg leading-tight">{p.name}</h3>
                  <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-2">{p.note}</p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
